export class Job {
  constructor(
    public category: string = '',
    public client: JobClient = new JobClient(),
    public closed: boolean = false,
    public company: string = '',
    public countries: string[] = [],
    public createdBy: string = '',
    public createdDate: string = '',
    public currency: string = '',
    public deleted: boolean = false,
    public description: string = '',
    public draft: boolean = false,
    public email: string = '',
    public externalId: string = '',
    public featured: boolean = false,
    public hash: string = '',
    public id: string = '',
    public image: string | null = null,
    public jobApplicationsSize: number = 0,
    public jobProvider: string | null = null,
    public location: string = '',
    public maxSalary: string = '',
    public metrics: any[] = [],
    public minSalary: string = '',
    public name: string = '',
    public owner: JobOwner = new JobOwner(),
    public postedDate: string = '',
    public published: boolean = false,
    public region: string | null = null,
    public skills: JobSkill[] = [],
    public subCategory: string = '',
    public url: string = '',
    public clientId: string = '',
    public jobName: string = '',
    public postedOn: string = '',
    public numberOfApplications: string = '',
    public status: string = ''
  ) {}
}

export class JobClient {
  constructor(
    public active: boolean = true,
    public createdBy: string = '',
    public createdDate: string = '',
    public currency: string | null = null,
    public id: string = '',
    public name: string = '',
    public primaryContact: string | null = null,
    public primaryEmail: string | null = null,
    public primaryPhoneNumber: string | null = null,
    public website: string = ''
  ) {}
}

export class JobOwner {
  constructor(
    public admin: boolean = false,
    public companyId: string = '',
    public companyName: string = '',
    public companySet: boolean = false,
    public createdBy: string = '',
    public createdDate: string = '',
    public deleted: boolean = false,
    public email: string = '',
    public emailNotifiable: boolean = true,
    public enabled: boolean = true,
    public firstname: string = '',
    public fullname: string = '',
    public id: string = '',
    public lastname: string = '',
    public phoneNumber: string = '',
    public profileSet: boolean = false,
    public userFile: any = null,
    public username: string = '',
    public whatsappNotifiable: boolean = false
  ) {}
}

export class JobSkill {
  constructor(
    public id: string = '',
    public skillLevel: string = '',
    public skillName: string = ''
  ) {}
}

export class TechnicalSkills {
  constructor(public name: string = '') {}
}

export class Skill {
  constructor(
    public id: string = '',
    public skillName: string = '',
    public skillLevel: string = ''
  ) {}
}

export interface RecommendationCandidate {
  id: string;
  candidateId: string;
  firstname: string;
  lastname: string;
  email: string;
  phoneNumber: string;
  profileURL: string;
  active: boolean;
  relevance: number;
  matchedSkillCount?: number;
  totalJobSkills?: number;
  aiBriefScore?: boolean;
}
